// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import {startCase} from 'lodash';

// Components
import Button from '../core/button';
import Form from '../core/form';
import Input from '../core/input';
import Permissions from '../core/permissions';
import SubmitButton from '../core/submit-button';
import RolesTree from './roles-tree';

// Styles
import './role-form.scss';

function RoleForm({formName, name, onReset}) {
    const getFieldProps = (fieldName, type) => ({
        className: type === 'checkbox' ? 'role-form--checkbox' : 'role-form--input',
        label: startCase(fieldName),
        name: fieldName,
        type,
    });

    const handleResetClick = (event) => {
        event && event.preventDefault && event.preventDefault();

        onReset();
    };

    const formProps = {
        className: 'role-form',
        fixedPositionedResponse: true,
        name: formName,
        resetOnSubmit: formName === 'createRole',
        submitData: true,
    };

    return (
        <Permissions adminOnly={true} notAuthorizedMessage={true}>
            <Form {...formProps}>
                <Input {...getFieldProps('name')} disableAutofill={true} label="Name" validate={['required', 'role']} />
                <div className="role-form--checkbox-list">
                    <label className="role-form--label">Child Roles</label>
                    <RolesTree
                        className="role-form--roles-tree"
                        disabledRoles={[name]}
                        name="childRoles"
                        validate={['required']}
                    />
                </div>
                <SubmitButton label="Save" />
                <Button
                    {...{
                        onClick: handleResetClick,
                        className: 'role-form--reset',
                    }}
                >
                    Reset
                </Button>
            </Form>
        </Permissions>
    );
}

RoleForm.propTypes = {
    formName: PropTypes.string.isRequired,
    name: PropTypes.string,
    onReset: PropTypes.func,
};

export default RoleForm;
